import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { formatedDate } from 'lib/dayjs'
import colors from 'styles/colors'
import { type AnalyticsContentFeedCard } from 'types/api/analytic'

interface FeedAnalyticsCardContentProps {
    card: AnalyticsContentFeedCard,
    sort?: any
    index?:any
}

type SortByKey = keyof AnalyticsContentFeedCard;

interface Sort {
    sort_by: SortByKey;
}

export function FeedAnalyticsCardContent({
    card,
    sort,
    index
}: FeedAnalyticsCardContentProps) {
    const { t } = useTranslation()
    return (
        <CardContent>
            <CardRank>
                {/* {t('rank')} <Number>{card.rank}</Number> */}
                {t('rank')} <Number>{index + 1}</Number>
            </CardRank>
            <CardCategories>
                {t('category')}{' '}
                <CategoryType>
                    {card.category.map(category => `${category.name} `)}
                    {card.category.length === 0 && t('none')}
                </CategoryType>
            </CardCategories>
            <ContentTypeWrapper>
            <ContentType>
            {sort?.sort_by === 'date_published'
                ? t('overall_revenue') // Custom label for default view
                : t(sort?.sort_by || 'purchase')} {/* fallback if null */}

                <Percentage>
                    
                    {sort ? (() => {

                        if (!sort || sort.sort_by === 'date_published') {
                            // Default display is overall revenue even if sorted by date
                            return `$${card?.overall_revenue.toFixed(2)}`;
                        }

                        switch (sort.sort_by) {
                            case 'tip_quantity':
                                return String(card?.tips_count);
                            case 'purchase_quantity':
                                return String(card?.purchases_count);
                            case 'date_published':
                                return formatedDate(card?.created_at, 'MMM D, h:mm A');
                            case 'tips':
                                return `$${card?.tips.toFixed(2)}`;        
                            case 'overall_revenue':
                                return `$${card?.overall_revenue.toFixed(2)}`;    
                            case 'purchases':
                                return `$${card?.purchases.toFixed(2)}`;    
                            default:
                                return String(card[sort.sort_by as keyof AnalyticsContentFeedCard]);
                        }
                    })() : `${Math.round(card.purchase_impression_rate)}%`}
                </Percentage>

            </ContentType>

            </ContentTypeWrapper>
        </CardContent>
    )
}

const CardContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`

const CardRank = styled.div`
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 1.4rem;
    color: ${colors.blueDark};
    display: flex;
    align-items: center;
`
const Number = styled.span`
    background: #e7e7e7;
    width: 2.4rem;
    height: 2.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 1.4rem;
    color: ${colors.blueLighter};
    margin-left: 0.3rem;
    border-radius: 0.5rem;
`
const CardCategories = styled.div`
    color: #afafaf;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 500;
    font-size: 1.2rem;
    margin: 0.8rem 0;
`
const CategoryType = styled.span`
    color: ${colors.blueDark};
`
const ContentTypeWrapper = styled.div`
    display: flex;
`
const ContentType = styled.div`
    padding: 0.5rem;
    border-radius: 0.5rem;
    background: #e7e7e7;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 500;
    font-size: 1.1rem;
    color: #828c94;
    width: auto;
    white-space: nowrap;
`
const Percentage = styled.span`
    color: ${colors.blueLighter};
`
